import { ChangeDetectionStrategy, Component, Input, OnInit, Type } from '@angular/core';
import { faCogs } from '@fortawesome/pro-duotone-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { map, switchMap } from 'rxjs/operators';
import { ISpecificBrickSettingsComponent } from './brick-specific-type-settings/ISpecificBrickSettingsComponent';
import { BrickInstancesSelectors } from '../../../store/dashboard/brick-wall/brick-instances/brick-instances.selectors';
import { IBrickDescription } from '../../../store/dashboard/brick-wall/brick-instances/brick-instances.state';
import { CloseBrickSettingsDialog } from '../../../store/dashboard/brick-wall/brick-settings/brick-settings.actions';
import { WellKnownIconsEnum } from 'src/app/helper/iconHelper';

@Component({
   selector: 'samweb-brick-settings',
   templateUrl: './brick-settings.component.html',
   styleUrls: ['./brick-settings.component.scss'],
   changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrickSettingsComponent implements OnInit {
   public categoryIconCommon = faCogs;

   public saveIcon: IconDefinition = WellKnownIconsEnum.SAVE.icon;
   public cancelIcon: IconDefinition = WellKnownIconsEnum.CANCEL.icon;

   @Input()
   public brickInstanceId: string;

   public brickDescription$: Observable<IBrickDescription>;
   public specificSettingsTabTitle$: Observable<string>;
   public settingsComponent$: Observable<Type<ISpecificBrickSettingsComponent>>;

   constructor(private store: Store, private translationService: TranslateService) {}

   ngOnInit() {
      this.brickDescription$ = this.store.select(BrickInstancesSelectors.brickDescriptionFn).pipe(map((fn) => fn(this.brickInstanceId)));
      this.settingsComponent$ = this.store.select(BrickInstancesSelectors.getBrickSettingsComponentFn).pipe(map((fn) => fn(this.brickInstanceId)));

      this.specificSettingsTabTitle$ = this.brickDescription$.pipe(
         map((x) => x.definition.brickTitleTranslationKey),
         switchMap((brickTitleTranslationKey) => this.translationService.stream(brickTitleTranslationKey))
      );
   }

   closeDialog() {
      this.store.dispatch(new CloseBrickSettingsDialog(true));
   }
}
